import { atom } from 'nanostores';

export const $termsModalOpen = atom<boolean>(false);

export const openTermsModal = () => {
  $termsModalOpen.set(true);
};

export const closeTermsModal = () => {
  $termsModalOpen.set(false);
};
